import LinkMembershipRequestModelBase from '../_generated/modelBases/link-membership-request-model-base';

export default class LinkMembershipRequestModel extends LinkMembershipRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
